import React from 'react';
import { Button } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../FieldGroup.jsx';
import { FormError } from '../FormError.jsx';

const SignInSsoForm = (props) => {
  const {
    userOrganizations,
    values,
    handleSubmit,
    submitFailed,
    submitError,
    submitting,
  } = props;

  return !userOrganizations ? (
    <form onSubmit={handleSubmit}>
      <h5 className="text-muted m-b-32 m-t-32">Please enter your email</h5>
      <Field
        id="email"
        name="email"
        label="Email"
        type="email"
        component={FieldGroup}
      />
      {submitFailed && <FormError submitError={submitError} />}
      <Button
        block
        bsSize="lg"
        bsStyle="primary"
        disabled={submitting}
        type="submit"
        onClick={() => handleSubmit()}
      >
        Continue
      </Button>
    </form>
  ) : (
    <React.Fragment>
      <h5 className="text-muted m-b-32 m-t-32">
        Please Select your Organization
      </h5>
      {userOrganizations.map((org) => (
        <Button
          key={org.id}
          disabled={submitting}
          className="flex flex-center flex-align-center btn btn-outlined-grey-border text-center m-b-24 w-100"
          style={{
            height: '36px',
          }}
          type="button"
          onClick={() => {
            values.clientId = org.sso.clientId;
            values.issuer = org.sso.issuer;
            values.email = null;
            handleSubmit();
          }}
        >
          {!org.logo || (org.logo && org.logo.includes('images/logo.png')) ? (
            org.name
          ) : (
            <img
              src={org.logo}
              alt={org.name}
              style={{
                height: '100%',
                width: 'auto',
                objectFit: 'contain',
                marginRight: '8px',
              }}
            />
          )}
        </Button>
      ))}
      {submitFailed && <FormError submitError={submitError} />}
    </React.Fragment>
  );
};

export default SignInSsoForm;
